import { Control } from "ol/control";
import React from "react";
import ReactDOM from "react-dom/client";

export default class SwipeControlOL extends Control {
  constructor(reactElement: React.ReactNode, options: any = {}) {
    const element = document.createElement("div");
    element.className = "ol-swipe-tool";

    super({
      element,
      target: options.target,
    });

    // Render React into this control
    const root = ReactDOM.createRoot(element);
    root.render(reactElement);
  }
}